import { useLingui } from '@lingui/react/macro'
import { Button } from 'designSystem/components/Button'
import { coarsePointerNoBackdropBlur } from 'features/knowledgeDocumentViewer/components/viewer/shared/coarsePointerNoBackdropBlur'
import { Minimize2 } from 'lucide-react'
import styled from 'styled-components'

import { PageSelector } from './PageSelector'

const OverlayBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 11;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: calc(0.5rem + env(safe-area-inset-top, 0px))
    calc(0.75rem + env(safe-area-inset-right, 0px)) 0.5rem
    calc(0.75rem + env(safe-area-inset-left, 0px));
  pointer-events: none;
`

const OverlayCluster = styled.div`
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background-color: color-mix(in srgb, var(--card) 50%, transparent);
  backdrop-filter: blur(2rem);
  -webkit-backdrop-filter: blur(2rem);
  ${coarsePointerNoBackdropBlur}
`

interface DocumentFullscreenOverlayProps {
  onExit: () => void
}

export function DocumentFullscreenOverlay({
  onExit,
}: DocumentFullscreenOverlayProps) {
  const { t } = useLingui()
  return (
    <OverlayBar>
      <OverlayCluster>
        <PageSelector />
        <Button
          type='button'
          variant='ghost'
          size='icon-lg'
          onClick={onExit}
          title={t`Exit fullscreen`}
          aria-label={t`Exit fullscreen`}>
          <Minimize2 />
        </Button>
      </OverlayCluster>
    </OverlayBar>
  )
}
